export default __webpack_public_path__ + "static/media/ExpoHello.01e6b8f2.svg";